import { PropsWithChildren } from "react";
import { ServicesContext } from "./ServicesContext";
import { appServices } from "../../services/appServices";
import { useAuth0 } from "@auth0/auth0-react";
import { useCachedAccessToken } from "@/hooks/useCachedAccessToken";

const ServicesProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const { isAuthenticated } = useAuth0();
  const getCachedToken = useCachedAccessToken();
  const services = appServices(getCachedToken, () => isAuthenticated);
  return (
    <ServicesContext.Provider value={services}>
      {children}
    </ServicesContext.Provider>
  );
};

export default ServicesProvider;
